module.exports = __webpack_public_path__ + "img/355.65764824.png";